// extracted by mini-css-extract-plugin
export default {"answers-box":"AnswersBox_answers-box__QGr5q"};